import {useRef, useState, useEffect} from 'react'
import Modal from '@/components/Modal/Modal.jsx'
import { Button, Tag, Form, Input, Space, message } from 'antd'
import StoryType from '@/components/SoftwareMap/nodes/BDSUMMARY/StoryType.jsx'
import Table from "@/biz/Table";
import Select from '@/components/Form/Select.jsx'
import { CheckCircleOutlined, SearchOutlined, CloseCircleOutlined } from '@ant-design/icons'
import useHTTP from '@/hooks/useHTTP.mjs'

const columns = [
  {
    title: "程序模块名称",
    dataIndex: "bdName",
    component: <Table.ViewText />,
  },
  {
    title: "程序模块代码",
    dataIndex: "bdNo",
    component: <Table.ViewText />,
  },
  {
    title: "用户场景类型",
    dataIndex: "storyType",
    component: <Table.ViewDict dict={Object.fromEntries(StoryType)} />,
  },
  {
    title: "用户场景标题",
    dataIndex: "algTitle",
    component: <Table.ViewText />,
  },

  {
    title: "版本号",
    dataIndex: "ver",
    width: 60,
    getValue: ({ rev, sVer }) => `${sVer}.${rev}`,
    component: <Table.ViewText />,
  },

  // {
  //   title: "模型成品版本号",
  //   dataIndex: "patternRevConcatString",
  //   width: 120,
  //   component: <Table.ViewText />,
  // },
].filter((v) => v);

const logicColumns = [
  {
    title: "程序模块名称",
    dataIndex: "bdName",
    component: <Table.ViewText />,
  },
  {
    title: "程序模块代码",
    dataIndex: "bdNo",
    component: <Table.ViewText />,
  },
  {
    title: "程序能力标题",
    dataIndex: "ruleTitle",
    component: <Table.ViewText />,
  },
  {
    title: "版本号",
    dataIndex: "ver",
    width: 60,
    getValue: ({ rev, sVer }) => `${sVer}.${rev}`,
    component: <Table.ViewText />,
  },

  // {
  //   title: "模型成品版本号",
  //   dataIndex: "patternRevConcatString",
  //   width: 120,
  //   component: <Table.ViewText />,
  // },
].filter((v) => v);

export default function ModalImport({
    prjData,
    type,
    onOk,
    ...props
}) {
    const refSelectedItem = useRef()
    const http = useHTTP();
    const [tabeleData, setTableData] = useState();
    const [loading, setLoading] = useState(false);
    // const [innerVisible, setInnerVisible] = useState(false)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    useEffect(() => {
      //  setInnerVisible(true)
      if (type == "BDSUMMARY") {
        fetchData()
      }else {
        fetchBdData()
      }
    }, [])

    const handleRowClick = (record) => {
      if(selectedRowKeys.includes(record.pkid)) {
        const uniqueId = selectedRowKeys.filter(item => item !== record.pkid)
        setSelectedRowKeys(uniqueId)
      }else {
        setSelectedRowKeys([...selectedRowKeys, record.pkid]);
      }
    };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, selectedRows) => {
      setSelectedRowKeys(keys);
    },
  };

  const fetchData = (query = {}) => {
    setLoading(true);
    http.get('/dmbds/scenes', {
      stsCodes: 'RLS,REVISE',
      sortMode: 1,
      algType: 'DATAFLOW',
      // prjId: prjData.prjId,
      // bfId: prjData.pkid,
      // sVer: prjData.sVer,
      ...prjData,
      ...query,
    }).then((data) => {
        setTableData(data)
        setLoading(false);
      }).catch(err => {
        setLoading(false);
      });
  };

  const fetchBdData = (query) => { 
    setLoading(true);
    http.get('/dmbds/rules', {
      stsCodes: 'RLS,REVISE',
      ruleTypes: ['BL', 'BT', 'INF', 'TIME'],
      sortMode: 'UPT_TIME',
      prjId: prjData.prjId,
      sVer: prjData.sVer,
      ...query,
    }).then((data) => {
        setTableData(data)
        setLoading(false);
      }).catch(err => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    // fetchData(values);
    if (type == "BDSUMMARY") {
        fetchData(values)
      }else {
        fetchBdData(values)
      }
  };
    const handleOk = () => onOk(selectedRowKeys)

    return (
        <Modal
            title={`选择${type == 'BDSUMMARY' ? "用户场景" : "程序能力"}`}
            width={1280}
            style={{ top: 80 }}
            bodyStyle={{
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              maxHeight: "calc(80vh - 100px)",
              minHeight: 320,
              background: "#fff",
              padding: "16px 24px",
            }}
            destroyOnClose
            onOk={handleOk}
            {...props}
        >
            {type == "BDSUMMARY" && (
              <>
                <Form
                  name="queryForm"
                  // labelCol={{ span: 8 }}
                  // wrapperCol={{ span: 16 }}
                  layout="vertical"
                  onFinish={onFinish}
                  autoComplete="off"
                  size="middle"
                >
                  <Space>
                    <Form.Item name="bdName" label="程序模块名称">
                      <Input size="middle" placeholder="请输入" allowClear />
                    </Form.Item>
                    <Form.Item name="bdNo" label="程序模块代码">
                      <Input size="middle" placeholder="请输入" allowClear />
                    </Form.Item>
                    <Form.Item name="algTitle" label="用户场景标题">
                      <Input size="middle" placeholder="请输入" allowClear />
                    </Form.Item>
                    <Form.Item
                      style={{ width: "200px" }}
                      name="storyType"
                      label="用户场景类型"
                    >
                      <Select placeholder="请选择" allowClear options={StoryType} />
                    </Form.Item>
            
    
                    <Form.Item
                      style={{ width: "120px" }}
                      label=" "
                      wrapperCol={{ offset: 8 }}
                    >
                      <Button
                        //@ts-ignore
                        icon={<SearchOutlined />}
                        type="primary"
                        htmlType="submit"
                      >
                        搜索
                      </Button>
                    </Form.Item>
                  </Space>
                </Form>
    
                <Table
                  loading={loading}
                  rowSelection={{
                    type: "checkbox",
                    ...rowSelection,
                  }}
                  rowKey={"pkid"}
                  columns={columns}
                  dataSource={tabeleData}
                  onRow={(record) => ({
                    onClick: () => handleRowClick(record), // 点击行选中
                  })}
                />
              </>
            )}
            {
              type == "BDLOGIC" && (
                <>
                  <Form
                    name="queryForm"
                    // labelCol={{ span: 8 }}
                    // wrapperCol={{ span: 16 }}
                    layout="vertical"
                    onFinish={onFinish}
                    autoComplete="off"
                    size="middle"
                  >
                    <Space>
                      <Form.Item name="bdName" label="程序模块名称">
                        <Input size="middle" placeholder="请输入" allowClear />
                      </Form.Item>
                      <Form.Item name="bdNo" label="程序模块代码">
                        <Input size="middle" placeholder="请输入" allowClear />
                      </Form.Item>
                      <Form.Item name="ruleTitle" label="程序能力标题">
                        <Input size="middle" placeholder="请输入" allowClear />
                      </Form.Item>
                      <Form.Item
                        style={{ width: "120px" }}
                        label=" "
                        wrapperCol={{ offset: 8 }}
                      >
                        <Button
                          //@ts-ignore
                          icon={<SearchOutlined />}
                          type="primary"
                          htmlType="submit"
                        >
                          搜索
                        </Button>
                      </Form.Item>
                    </Space>
                  </Form>
                  <Table
                    loading={loading}
                    rowSelection={{
                      type: "checkbox",
                      ...rowSelection,
                    }}
                    rowKey={"pkid"}
                    columns={logicColumns}
                    dataSource={tabeleData}
                    onRow={(record) => ({
                      onClick: () => handleRowClick(record), // 点击行选中
                    })}
                  />
                </>
              )
            }
        </Modal>
    )
}
